/**
 * WHERE A COMPETITION IS UP TO, in the organiser's words, with `ready` when the
 * next step is starting it. The row used to say only format and venue, and
 * tapping it reopened the wizard at Basics whatever stage it had reached.
 * Read off counts the list payload carries (`player_count`, `slot_count`,
 * `seated_count`, `is_tee_sheet_finalized`) — no request per row.
 */
export const stageFor = (t) => {
  if (t.is_advanced) return null;
  if (t.status === 'in_progress') {
    return { text: t.round_count > 1 ? `Round ${t.latest_round || 1} of ${t.round_count} in play` : 'In play' };
  }
  if (t.status !== 'not_started') return null;
  if (t.signup_mode === 'roll_up') {
    if (t.is_tee_sheet_finalized) return { text: 'Sheet finalised · ready to start', ready: true };
    if (!t.slot_count) return { text: 'Tee sheet to set up', todo: true };
    return { text: `${t.seated_count} of ${t.slot_count} slots taken` };
  }
  if (!t.player_count) return { text: 'No players yet', todo: true };
  if (t.seated_count < t.player_count) {
    return { text: `${t.seated_count} of ${t.player_count} placed in groups`, todo: true };
  }
  return { text: `Ready to start · ${t.player_count} players`, ready: true };
};
